import { $el, isNotThemeStore } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const scrollOptions = (jump: boolean): object => ({
  behavior: jump ? 'auto' : 'smooth',
  block: 'nearest',
})

export class ProductMedia extends BaseComponent {
  mountComponent(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(variant, jump = false): void {
    if (isNotThemeStore()) {
      if (variant && variant.featured_media) {
        const media = $el(
          `[data-media-id="${variant.featured_media.id}"]`,
          this,
        )

        const element = media ?? this

        element.scrollIntoView(scrollOptions(jump))
      }
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}
